import ManageMembership from '@/screens/join-premium/ManageMembership'

export default function () {
  return <ManageMembership />
}
